import {createMarquee} from "../../_functions";

const wrapper = document.querySelector('.about__image--marquee');
if (wrapper) createMarquee(".about__image--marquee", ".about__image--marquee-item", 40, 60);
